module.exports = __webpack_public_path__ + "static/media/finance.611e0d3a.png";